import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-main-container" }
const _hoisted_2 = { class: "h1 text-uppercase" }
const _hoisted_3 = { class: "h3 text-uppercase" }
const _hoisted_4 = { class: "h5 mb-32" }
const _hoisted_5 = { class: "mb-8 text-primary" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-home me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('Ups!')), 1),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('Te has perdido')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('No hemos podido encontrar la página que estás buscando.')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('Si quieres puedes ir a la página de inicio haciendo click en el siguiente botón:')), 1),
      _createVNode(_component_v_button, {
        type: "button",
        variant: "secondary",
        "aria-label": _ctx.$t('Inicio'),
        onClick: _ctx.redirect
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Inicio')), 1)
          ])
        ]),
        _: 1
      }, 8, ["aria-label", "onClick"])
    ])
  ]))
}